import React from "react";
import { motion } from "framer-motion";
import { ArrowForward } from "@mui/icons-material";

const stripHtml = (html) => {
  if (!html) return "";
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

const NewsSection = ({ news, loading, onView }) => {
  return (
    <motion.article
      className="news-card ne-card"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45 }}
      viewport={{ once: true }}
    >
      <div className="news-header card-header">
        <span className="section-kicker">Announcements</span>
        <h3>Latest Updates</h3>
      </div>

      <div className="news-list">
        {loading &&
          Array.from({ length: 3 }).map((_, i) => (
            <div className="news-item ne-skeleton" key={i} />
          ))}

        {!loading && news.length === 0 && (
          <div className="home-empty-state">No news updates yet.</div>
        )}

        {!loading &&
          news.map((n, i) => {
            const cleanText = stripHtml(n.summary);

            return (
              <motion.div
                key={n.id || i}
                className="news-item"
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.04 }}
                viewport={{ once: true }}
              >
                <div className="news-date">{n.createdDate || "New"}</div>

                <div className="news-body">
                  <h4>{n.headline}</h4>
                  <p>
                    {cleanText.length > 110
                      ? `${cleanText.slice(0, 110)}...`
                      : cleanText}
                  </p>
                </div>

                <button
                  className="news-btn"
                  type="button"
                  onClick={() => onView(n.id, n.headline, n.summary)}
                >
                  Read <ArrowForward fontSize="small" />
                </button>
              </motion.div>
            );
          })}
      </div>
    </motion.article>
  );
};

export default NewsSection;
